<template>
    <div>
        <search-list @search-data="getParams" class="mb16"></search-list>
        <div >
        <table-list

            :columns="columns"
            :data="data"
            :total="total"
            :loading="loading"
            :current="current"
            @change-page="getPage"
            @change-size="getSize"
        ></table-list>
        </div>
        <save-modal
            :n="key"
            :projectfid="projectFid"
            :roomfid="roomFid"
            :deivcetype="deivceType"
            :readingfid="readingFid"
            :readstatus="readStatus"
            @refresh="refreshTable"></save-modal>
    </div>
</template>

<script type="text/ecmascript-6">
import SearchList from './components/SearchList';
import TableList from 'components/TableList/index';
import SaveModal from './components/SaveModal';
import { getReadList } from "api/meterReading";
export default {
    name:'reading',
    components: {
        SearchList,
        TableList,
        SaveModal
    },
    data () {
        return {
            key:0,
            projectFid:"",
            roomFid:"",
            readingFid:"",
            readStatus:null,
            deivceType:null,
            columns:[
                {
                   type:'index',
                   width:60,
                   align:'center'
                },

                {
                    title:'状态',
                    align:'center',
                    width:100,
                    key:'readStatusCn',
                    render:(h,params) => {
                        return h('span',{
                           'class':{
                                    unplay:params.row.readStatus === 1,
                                    offline:params.row.readStatus === 0
                            }
                        },params.row.readStatusCn)
                    }
                },
                {
                    title:'项目',
                    align:'center',
                    width:250,
                    key:'projectName'
                },
                {
                    title:'房间号',
                    align:'center',
                    width:100,
                    key:'roomNumber'
                },
                {
                    title:'楼栋',
                    align:'center',
                    width:100,
                    key:'buildingName'
                },
                {
                    title:'楼层',
                    align:'center',
                    width:100,
                    key:'floorNumber'
                },
                {
                    title:'表类型',
                    align:'center',
                    width:100,
                    key:'deviceTypeCn'
                },
                 {
                    title:'上期示数',
                    align:'center',
                    width:100,
                    key:'preMeterReading'
                },
                 {
                    title:'上期抄表时间',
                    align:'center',
                    key:'preReadTime',
                    width:170,
                },
                {
                    title:'本期期数',
                    align:'center',
                    width:100,
                    key:'meterReading'
                },
                {
                    title:'本期抄表时间',
                    align:'center',
                    key:'readTime',
                    width:170,
                },
                {
                    title:'处理人',
                    align:'center',
                    width:100,
                    key:'handleName'
                },
                {
                    title:'处理时间',
                    align:'center',
                    key:'handleTime',
                    width:150,
                },
                {
                    title:'操作',
                    key:'action',
                    width:100,
                    align:'center',
                    fixed: "right",
                    render:(h,params) => {
                      return h('Button', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: params.row.readStatus === 0,
                        },
                        directives: [
                          {
                            name: 'p',
                            value: {
                              api: 'waterwatt/read/save'
                            }
                          }
                        ],
                        on: {
                          click: () => {
                            this.key++;
                            this.projectFid = params.row.projectFid;
                            this.roomFid = params.row.roomFid;
                            this.deivceType = params.row.deivceType;
                            this.readingFid = params.row.readingFid;
                            this.readStatus = params.row.readStatus;
                          }
                        }
                      }, '抄表')
                    }
                },
            ],
            data:[],
            total:0,
            loading:false,
            current:1,
            params:{
                projectFid:'',
                readStatus:null,
                page:1,
                limit:10,
            },
        }
    },
    created () {
        this.initReadList();
    },
    methods: {
        getPage(n) {
            this.current = n;
            this.params.page = n;
            this.initReadList();
        },
        initReadList() {
            getReadList(this.params).then(res => {
                this.data = res.data.rows;
                this.total = res.data.total;

            })
        },
        getParams(params){
            this.current = 1;
            this.params = params;
            this.initReadList();
        },
        refreshTable() {
            this.initReadList();
        },
        getSize(size){
            this.params.limit = size;
            this.initReadList();
        }
    }
}
</script>
